import React from 'react'
import Helmet from 'react-helmet'
import styled from 'styled-components'

import Message from '../components/message'
import Page from '../components/page'
import theme from '../utils/theme'

const ServiceGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: -1.5rem;
` 

const Service = styled.div`
  width: 100%;
  padding-left: 1.5rem

  > h2 {
    padding-top: 1rem;
    border-top: 1px solid ${theme.colors.lightTeal};
    font-size: 1.25rem;
  }

  @media (min-width: 32rem) {
    width: 50%;
  }
` 

const ServicesPage = ({data}) => (
  <Page>
    <Helmet>
      <title>Services Provided by {data.site.siteMetadata.title}</title>
    </Helmet>
    <h1>
      Creative Landscaping Services
    </h1>
    <p style={{fontSize: '1.25rem'}}>
      {data.site.siteMetadata.title} offers a unique perspective on plant design and artful attention to detail. We create outdoor living spaces by uniting architecture and landscape design. We focus on creative design, quality installation and meticulously managed grounds.
    </p>
    <ServiceGrid>
      <Service>
        <h2>
          Landscape Design
        </h2>
        <p>
          Personal client consultation, site inspection, custom hand-drawn design plans and detailed plant specifications.
        </p>
      </Service>
      <Service>
        <h2>
          Grounds Management
        </h2>
        <p>
          Customized grounds management program tailored to our clients needs. Year round grounds keeping on an equal monthly payment plan or seasonal maintenance.
        </p>
      </Service>
      <Service>
        <h2>
          Hardscape Installation
        </h2>
        <p>
          Quality stone and brick patios, walkways, retaining walls, natural stone features, fountains, driveways and more!
        </p>
      </Service>
      <Service>
        <h2>
          Renovation
        </h2>
        <p>
          Landscape re-design, plant removal, specialized pruning and tree removal.
        </p>
      </Service>
      <Service>
        <h2>
          Specialty Services
        </h2>
        <p>
          Creative and unique pergolas, gazebos, serenity gardens, trellis and arbors, gates and fencing details.
        </p>
      </Service>
      <Service>
        <h2>
          Irrigation &amp; Outdoor Illumination
        </h2>
        <p>
          Customized irrigation plans and installation to protect and display your outdoor investment.
        </p>
      </Service>
    </ServiceGrid>
    <Message>
      Call to schedule a free estimate {data.site.siteMetadata.phone}
    </Message>
  </Page>
)

export default ServicesPage

export const query = graphql`
  query ServicesQuery {
    site {
      siteMetadata {
        title
        phone
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/services.js